/**
 * Tool surface module — DEPRECATED, scheduled for removal.
 *
 * Previously controlled write-tool visibility. Write tools are now always
 * visible; handler-level guards (requireWriteAccess) enforce access.
 *
 * Both exports are no-ops retained solely for call-site compatibility.
 * A future cleanup slice should remove all `trackWriteTool` / `initToolSurface`
 * call sites and delete this file.
 */

/** @deprecated No-op. Remove call sites and delete this module. */
export function initToolSurface(): void {}

/** @deprecated No-op. Remove call sites and delete this module. */
export function trackWriteTool(_tool: unknown): void {}
